import { createContext } from 'react';

export type LogoutCtx = {
  showLogoutAlert: boolean;
  isSuspiciousLogin: boolean;
};

const LogoutDialogueContext = createContext<LogoutCtx>({
  showLogoutAlert: false,
  isSuspiciousLogin: false,
});

export default LogoutDialogueContext;
